import React from 'react';
import styles from './ExportButton.module.css';
import { useExport } from './ExportCore';

const loadingSrc = require('../../../images/loading.svg');

const ExportButton = ({
    // Button styling
    disabled = false,
    buttonClassName = '',
    textClassName = '',
    loadingClassName = '',
    buttonCaption = '',
    ariaLabel = '',

    // Export configuration (passed to useExport)
    fetchData = async () => [],
    fileNamePrefix = 'Export',
    sheetName = 'Sheet1',
    exportType = 'excel',
    isFileDownload = false,
    mimeType = null,
    fileExtension = null,
    onExportStart = () => { },
    onExportComplete = () => { },
    onExportError = () => { }
}) => {
    // Use the export hook for the core functionality
    const { isExporting, handleExport } = useExport({
        fetchData,
        fileNamePrefix,
        sheetName,
        exportType,
        isFileDownload,
        mimeType,
        fileExtension,
        onExportStart,
        onExportComplete,
        onExportError
    });

    const buttonClasses = [
        styles.exportButtonBase,
        buttonClassName,
        isExporting ? loadingClassName : ''
    ].filter(Boolean).join(' ');

    const displayCaption = buttonCaption !== ""
        ? buttonCaption
        : exportType === 'excel' ? 'Export' : 'Download';

    return (
        <button
            disabled={disabled || isExporting}
            className={buttonClasses}
            onClick={handleExport}
            aria-busy={isExporting}
            aria-label={ariaLabel || displayCaption}
        >
            <span className={textClassName}>
                {displayCaption}
                {isExporting && (
                    <img
                        src={loadingSrc}
                        height="20"
                        alt="Loading"
                        style={{ marginLeft: '1px' }}
                    />
                )}
            </span>
        </button>
    );
};

export default ExportButton;

